import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {FeatureFlagData} from "../../services/feature-flag/feature-flag-data.model";


@Component({
  selector: 'sb-feature-flag',
  templateUrl: './feature-flag.component.html',
  styleUrls: ['./feature-flag.component.scss']
})
export class FeatureFlagComponent implements OnInit {

  constructor() {
  }

  @Input() flag: FeatureFlagData;

  @Output() toggled: EventEmitter<any> = new EventEmitter();

  enable() {
    this.toggled.emit(Object.assign({}, this.flag, { active: true }));
  }

  disable() {
    this.toggled.emit(Object.assign({}, this.flag, { active: false }));
  }

  ngOnInit() {
  }

}
